import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  position: relative;
  background-size: cover;
  height: 100vh;

  .pro-sidebar {
    z-index: 999;
  }
`

export const Main = styled.div<{
  isHomepage: boolean
}>`
  padding: 24px 0 10px 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    !props.isHomepage ? 'space-between' : undefined};
  overflow: hidden;

  @media (max-width: 768px) {
    padding-top: 0;
  }
`

export const Part1 = styled.div<{
  isdark: boolean
}>`
  @media (max-width: 768px) {
    background-color: ${(props) => (props.isdark ? '#051f31' : '#fff')};
    padding: 5px;
    width: 100%;
    height: 70px;
    line-height: 70px;
    display: flex;
    justify-content: space-between;
  }
`

export const BtnToggle = styled.div`
  cursor: pointer;
  width: 60px;
  height: 60px;
  color: #fff;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  display: none;

  @media (max-width: 768px) {
    display: flex;
  }
`

export const MBody = styled.div<{
  isHomepage: boolean
}>`
  overflow-x: ${(props) => (props.isHomepage ? 'hidden' : 'auto')};
  overflow-y: ${(props) => (props.isHomepage ? 'scroll' : 'none')};
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.isHomepage ? 'space-between' : 'center'};
  flex: 1 1 auto;
  gap: 1rem;
  scrollbar-width: none;

  @media (max-width: 768px) {
    padding-top: 30px;
    margin-bottom: 2rem;
  }
`
